import type {
  Concept,
  ConcreteEntityType,
  LinkTargetConcreteEntityType} from 'types';
import {
  LinkTargetConcreteEntityTypes,
} from 'types';

export const isConcreteLinkTargetEntity = (
  entity: Concept | undefined,
): entity is ConcreteEntityType => {
  if (!entity) {
    return false;
  }

  return LinkTargetConcreteEntityTypes.includes(
    entity as LinkTargetConcreteEntityType,
  );
};
